module.exports = __webpack_public_path__ + "img/CAIFF-logo.8ecdea02.png";